import { useMemo } from 'react';

import { lightTheme as theme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { COUNTER_PARTY_STATUS_LABEL } from '#client/constants/payees';
import {
  AUTHORIZATION_TRANSACTION_STATUS,
  CHECK_DEPOSIT_STATUS,
  PAYMENT_STATUS
} from '#client/constants/transaction';
import { addSpaceAndCapitalizeFirstLetter } from '#client/utils/text';

import { LabelStyled } from './PaymentStatusLabel.styles';

export default function PaymentStatusLabel({ status }) {
  const bgColor = useMemo(() => {
    switch (status) {
      case PAYMENT_STATUS.SENT:
        return theme.palette.background.green.light;
      case PAYMENT_STATUS.REJECTED:
      case PAYMENT_STATUS.CANCELED:
      case PAYMENT_STATUS.RETURNED:
      case COUNTER_PARTY_STATUS_LABEL.NO_LONGER_LINKED:
      case CHECK_DEPOSIT_STATUS.REJECTED:
      case CHECK_DEPOSIT_STATUS.CANCELED:
      case CHECK_DEPOSIT_STATUS.RETURNED:
        return theme.palette.background.red.light;
      case CHECK_DEPOSIT_STATUS.PROCESSING:
      case AUTHORIZATION_TRANSACTION_STATUS.AUTHORIZED:
        return theme.palette.background.orange.light;
      case PAYMENT_STATUS.PENDING:
      case PAYMENT_STATUS.CLEARING:
      case PAYMENT_STATUS.PENDING_REVIEW:
      case CHECK_DEPOSIT_STATUS.CLEARING:
      default:
        return theme.palette.background.grey.main;
    }
  }, [status]);

  return (
    <LabelStyled
      aria-label="label"
      bgColor={bgColor}
    >
      <Text
        color="primary"
        size="xs"
        textAlign="center"
        whiteSpace="nowrap"
      >
        {addSpaceAndCapitalizeFirstLetter(status)}
      </Text>
    </LabelStyled>
  );
}

PaymentStatusLabel.propTypes = {
  status: PropTypes.string.isRequired
};
